// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListComponents-module__dsAccented--IAQiB,.ListComponents-module__dsAccented--IAQiB *{font-weight:500}.ListComponents-module__dsDefaultWeight--cSH0u,.ListComponents-module__dsDefaultWeight--cSH0u *{font-weight:400}h5.ListComponents-module__dsAccented--IAQiB,h5.ListComponents-module__dsAccented--IAQiB *{font-weight:700}.ListComponents-module__dsUnderline--Fqs6b,.ListComponents-module__dsUnderline--Fqs6b *{text-decoration:underline}.ListComponents-module__dsAccented2--_IXGY,.ListComponents-module__dsAccented2--_IXGY *{font-weight:700}.ListComponents-module__dsBodyXL--UQA1S,.ListComponents-module__dsBodyXL--UQA1S *{font-size:18px;line-height:27px}.ListComponents-module__dsBodyLarge--cBTzJ,.ListComponents-module__dsBodyLarge--cBTzJ *{font-size:16px;line-height:24px}.ListComponents-module__dsBody--ZH9CQ,.ListComponents-module__dsBody--ZH9CQ *{font-size:14px;line-height:20px}.ListComponents-module__dsBodySmall--xG5WI,.ListComponents-module__dsBodySmall--xG5WI *{font-size:12px;line-height:18px}.ListComponents-module__dsBodyXS--lPrHq,.ListComponents-module__dsBodyXS--lPrHq *{font-size:10px;line-height:15px}.ListComponents-module__dsActionLarge--fKKf8,.ListComponents-module__dsActionLarge--fKKf8 *{font-size:16px;line-height:18px}.ListComponents-module__dsAction--TV22y,.ListComponents-module__dsAction--TV22y *{font-size:14px;line-height:16px}.ListComponents-module__dsActionSmall--KNAsy,.ListComponents-module__dsActionSmall--KNAsy *{font-size:12px;line-height:14px}.ListComponents-module__dsColumnHeadLine--AeeyO,.ListComponents-module__dsColumnHeadLine--AeeyO *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.ListComponents-module__dsLightXL--s_SVu,.ListComponents-module__dsLightXL--s_SVu *{font-size:120px;line-height:160px;font-weight:300}.ListComponents-module__dsLightLarge--JMCHA,.ListComponents-module__dsLightLarge--JMCHA *{font-size:48px;line-height:64px;font-weight:300}.ListComponents-module__dsLight--UIvuS,.ListComponents-module__dsLight--UIvuS *{font-size:32px;line-height:64px;font-weight:300}.ListComponents-module__dsLightSmall--mxaMR,.ListComponents-module__dsLightSmall--mxaMR *{font-size:24px;line-height:36px;font-weight:300}.ListComponents-module__dsLightXS--xgD7L,.ListComponents-module__dsLightXS--xgD7L *{font-size:18px;line-height:27px;font-weight:300}.ListComponents-module__secondaryText--kvNec{color:#8c95a8;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;word-break:break-word}.ListComponents-module__secondaryText--kvNec.ListComponents-module__disabled--FXSCB{color:#b3b9c8}.ListComponents-module__prefixContainer--OP4T8{margin-right:12px;display:flex;align-items:center}.ListComponents-module__prefixContainer--OP4T8 .ListComponents-module__prefixElementContainer--JNnhn{display:flex}.ListComponents-module__prefixContainer--OP4T8>.ListComponents-module__prefixElementContainer--JNnhn:not(:first-of-type){margin-left:6px}.ListComponents-module__prefixContainer--OP4T8.ListComponents-module__atTheTop--ac_tB{margin-bottom:auto;margin-top:2px}.ListComponents-module__textContainer--nyDAS{display:flex;flex-direction:column;justify-content:center;flex-grow:1;min-width:0}.ListComponents-module__primaryText--Ncb52{overflow:hidden;text-overflow:ellipsis;color:#191a1c;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-word}.ListComponents-module__primaryText--Ncb52.ListComponents-module__disabled--FXSCB{color:#b3b9c8}.ListComponents-module__prefixIconContainer--d_N2y{display:flex;align-items:center}.ListComponents-module__radioContainer--Anme9{display:flex;align-items:center}.ListComponents-module__colorContainer--rH4AK{width:12px;height:12px;border-radius:100%;background-color:var(--item-color)}.ListComponents-module__imgContainer--CwGY7{width:24px;height:24px;display:flex;align-items:center}.ListComponents-module__imgContainer--CwGY7 img{width:100%;border-radius:100%}.ListComponents-module__actionsContainer--WjSTB{display:flex;align-items:center;margin-left:auto}.ListComponents-module__actionsContainer--WjSTB.ListComponents-module__small--jIexI .ListComponents-module__actionContainer--H5jvp:not(:last-of-type){margin-right:4px}.ListComponents-module__bigImg--pHcRl{width:32px;height:32px}.ListComponents-module__moreTopIconMargin--rj5hh{margin-top:2px}.ListComponents-module__moreTopColorMargin--O9p5P{margin-top:2px}.ListComponents-module__moreTopRadioButtonMargin--LDVpy{margin-top:2px}.ListComponents-module__moreTopCheckboxMargin--Tmkad{margin-top:2px}.ListComponents-module__stickToTheTopActions--cJc9e{margin-bottom:auto}.ListComponents-module__stickToTheTopActions--cJc9e.ListComponents-module__large--EdzNO{margin-top:-4px}.ListComponents-module__submenuIconContainer--dMLc9{display:flex;align-items:center;justify-content:center;color:var(--gray-6)}.ListComponents-module__submenuPopper--wEJpS{margin:0 !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `ListComponents-module__dsAccented--IAQiB`,
	"dsDefaultWeight": `ListComponents-module__dsDefaultWeight--cSH0u`,
	"dsUnderline": `ListComponents-module__dsUnderline--Fqs6b`,
	"dsAccented2": `ListComponents-module__dsAccented2--_IXGY`,
	"dsBodyXL": `ListComponents-module__dsBodyXL--UQA1S`,
	"dsBodyLarge": `ListComponents-module__dsBodyLarge--cBTzJ`,
	"dsBody": `ListComponents-module__dsBody--ZH9CQ`,
	"dsBodySmall": `ListComponents-module__dsBodySmall--xG5WI`,
	"dsBodyXS": `ListComponents-module__dsBodyXS--lPrHq`,
	"dsActionLarge": `ListComponents-module__dsActionLarge--fKKf8`,
	"dsAction": `ListComponents-module__dsAction--TV22y`,
	"dsActionSmall": `ListComponents-module__dsActionSmall--KNAsy`,
	"dsColumnHeadLine": `ListComponents-module__dsColumnHeadLine--AeeyO`,
	"dsLightXL": `ListComponents-module__dsLightXL--s_SVu`,
	"dsLightLarge": `ListComponents-module__dsLightLarge--JMCHA`,
	"dsLight": `ListComponents-module__dsLight--UIvuS`,
	"dsLightSmall": `ListComponents-module__dsLightSmall--mxaMR`,
	"dsLightXS": `ListComponents-module__dsLightXS--xgD7L`,
	"secondaryText": `ListComponents-module__secondaryText--kvNec`,
	"disabled": `ListComponents-module__disabled--FXSCB`,
	"prefixContainer": `ListComponents-module__prefixContainer--OP4T8`,
	"prefixElementContainer": `ListComponents-module__prefixElementContainer--JNnhn`,
	"atTheTop": `ListComponents-module__atTheTop--ac_tB`,
	"textContainer": `ListComponents-module__textContainer--nyDAS`,
	"primaryText": `ListComponents-module__primaryText--Ncb52`,
	"prefixIconContainer": `ListComponents-module__prefixIconContainer--d_N2y`,
	"radioContainer": `ListComponents-module__radioContainer--Anme9`,
	"colorContainer": `ListComponents-module__colorContainer--rH4AK`,
	"imgContainer": `ListComponents-module__imgContainer--CwGY7`,
	"actionsContainer": `ListComponents-module__actionsContainer--WjSTB`,
	"small": `ListComponents-module__small--jIexI`,
	"actionContainer": `ListComponents-module__actionContainer--H5jvp`,
	"bigImg": `ListComponents-module__bigImg--pHcRl`,
	"moreTopIconMargin": `ListComponents-module__moreTopIconMargin--rj5hh`,
	"moreTopColorMargin": `ListComponents-module__moreTopColorMargin--O9p5P`,
	"moreTopRadioButtonMargin": `ListComponents-module__moreTopRadioButtonMargin--LDVpy`,
	"moreTopCheckboxMargin": `ListComponents-module__moreTopCheckboxMargin--Tmkad`,
	"stickToTheTopActions": `ListComponents-module__stickToTheTopActions--cJc9e`,
	"large": `ListComponents-module__large--EdzNO`,
	"submenuIconContainer": `ListComponents-module__submenuIconContainer--dMLc9`,
	"submenuPopper": `ListComponents-module__submenuPopper--wEJpS`
};
module.exports = ___CSS_LOADER_EXPORT___;
